import type { JSX } from "react";
import { type UseFieldConfig, useField } from "react-final-form";

interface IOwnProps {
    label?: string;
    placeholder?: string;
    name: string;
    className?: string;
    maxLength?: number;
}

type IProps = IOwnProps & UseFieldConfig;

function Input({ name, label, placeholder, className, maxLength, ...props }: IProps): JSX.Element {
    const {
        input,
        meta: { touched, error },
    } = useField<string, HTMLInputElement>(name, props);
    return (
        <div className={touched && error ? `error ${className}` : className || ""}>
            <label>
                {label && `${label}: `}
                <input {...input} placeholder={placeholder} maxLength={maxLength} />
                {touched && error && <small className="error">{error}</small>}
            </label>
        </div>
    );
}

export default Input;
